module.exports = __webpack_public_path__ + "media/images/common/shop/icon-staff-b800f2de0a384acd0f87fb09b5db6d1e.png";